export const removeEmojis = (str: string): string => {
  return str.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\u24C2|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDD00-\uDFFF])/g, "");
};

export const formatDate = (dateString: string): string => {
  const parsedDate = parseDate(dateString);
  if (parsedDate) {
    const day = String(parsedDate.getDate()).padStart(2, "0");
    const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
    const year = parsedDate.getFullYear();
    return `${day}-${month}-${year}`;
  }
  return "";
};

export const parseDate = (dateString: string): Date | null => {
  if (!dateString) return null;
  const numericDateRegex = /^(0?[1-9]|[12][0-9]|3[01])-(0?[1-9]|1[0-2])-(\d{4})$/;
  const numericMatch = dateString.match(numericDateRegex);

  if (numericMatch) {
    const [dayStr, monthStr, yearStr] = dateString.split("-");
    const month = parseInt(monthStr, 10);
    const day = parseInt(dayStr, 10);
    const year = parseInt(yearStr, 10);

    if (yearStr.length !== 4 || isNaN(year)) return null;
    if (month < 1 || month > 12) return null;
    if (day < 1 || day > 31 || !isValidDayForMonth(day, month, year)) return null;

    return new Date(year, month - 1, day);
  }
  return null;
};

export const isValidDayForMonth = (day: number, month: number, year: number): boolean => {
  const daysInMonth = [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  return day >= 1 && day <= daysInMonth[month - 1];
};

export const isLeapYear = (year: number): boolean => {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
};

export const isValidDate = (day: number, month: number, year: number): boolean => {
  if (month < 1 || month > 12) return false;
  if (year < 1000 || year > 9999) return false;

  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
};